import React from 'react';

export const InlineCode = ({ children }) => {
  return <code className="px-2 py-1 bg-gray-100 rounded text-sm text-gray-800">{children}</code>;
};
